import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchCreateBrokerLink } from '../shared/repositories/newbuilding-broker/v1/create-broker-link';
export function fetchBrokerLinkData(_x) {
  return _fetchBrokerLinkData.apply(this, arguments);
}
function _fetchBrokerLinkData() {
  _fetchBrokerLinkData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var newbuildingId, newbuildingRegionId, houseId, httpApi, logger, _yield$fetchCreateBro, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          newbuildingId = _ref.newbuildingId, newbuildingRegionId = _ref.newbuildingRegionId, houseId = _ref.houseId, httpApi = _ref.httpApi, logger = _ref.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchCreateBrokerLink({
            httpApi: httpApi,
            parameters: {
              newbuildingId: newbuildingId || undefined,
              regionId: newbuildingRegionId || undefined,
              houseId: houseId || undefined
            },
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              },
              ecnhancersConfig: {
                timeout: 25 * 1000
              }
            }
          });
        case 4:
          _yield$fetchCreateBro = _context.sent;
          response = _yield$fetchCreateBro.response;
          if (!('brokerUrl' in response && response.brokerUrl)) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", {
            alreadyRegistered: !!response.alreadyRegistered,
            brokerUrl: response.brokerUrl,
            brokerName: response.brokerName || ''
          });
        case 8:
          return _context.abrupt("return", {
            isError: true
          });
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'fetchBrokerLinkData'
          });
          return _context.abrupt("return", {
            isError: true
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return _fetchBrokerLinkData.apply(this, arguments);
}